var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.319824H7.2C2.604 0.319824 0 2.92383 0 7.51982V20.1199C0 24.7158 2.604 27.3198 7.2 27.3198H19.8121C24.408 27.3198 27 24.7158 27 20.1199V7.51982C27 2.92383 24.408 0.319824 19.8121 0.319824Z",
    fill: "#CE2600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5183_28560)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58984 10.6558H21.4102C21.7014 10.6558 21.9375 10.8919 21.9375 11.1831V13.2925C21.9375 13.5837 21.7014 13.8198 21.4102 13.8198H20.7669L18.7575 21.8576C18.729 21.9717 18.6632 22.0731 18.5705 22.1455C18.4778 22.2179 18.3636 22.2573 18.2459 22.2573H8.75376C8.63613 22.2573 8.52189 22.2179 8.4292 22.1455C8.33651 22.0731 8.2707 21.9717 8.24224 21.8576L6.23279 13.8198H5.58984C5.2986 13.8198 5.0625 13.5837 5.0625 13.2925V11.1831C5.0625 10.8919 5.2986 10.6558 5.58984 10.6558Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.1479C13.3601 20.1479 13.226 20.0924 13.1271 19.9935C13.0282 19.8946 12.9727 19.7605 12.9727 19.6206V16.4565C12.9727 16.3167 13.0282 16.1826 13.1271 16.0837C13.226 15.9848 13.3601 15.9292 13.5 15.9292C13.6399 15.9292 13.774 15.9848 13.8729 16.0837C13.9718 16.1826 14.0273 16.3167 14.0273 16.4565V19.6206C14.0273 19.7605 13.9718 19.8946 13.8729 19.9935C13.774 20.0924 13.6399 20.1479 13.5 20.1479Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8633 20.1479C10.7234 20.1479 10.5893 20.0924 10.4904 19.9935C10.3915 19.8946 10.3359 19.7605 10.3359 19.6206V16.4565C10.3359 16.3167 10.3915 16.1826 10.4904 16.0837C10.5893 15.9848 10.7234 15.9292 10.8633 15.9292C11.0031 15.9292 11.1373 15.9848 11.2362 16.0837C11.3351 16.1826 11.3906 16.3167 11.3906 16.4565V19.6206C11.3906 19.7605 11.3351 19.8946 11.2362 19.9935C11.1373 20.0924 11.0031 20.1479 10.8633 20.1479Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1367 20.1479C15.9969 20.1479 15.8627 20.0924 15.7638 19.9935C15.6649 19.8946 15.6094 19.7605 15.6094 19.6206V16.4565C15.6094 16.3167 15.6649 16.1826 15.7638 16.0837C15.8627 15.9848 15.9969 15.9292 16.1367 15.9292C16.2766 15.9292 16.4107 15.9848 16.5096 16.0837C16.6085 16.1826 16.6641 16.3167 16.6641 16.4565V19.6206C16.6641 19.7605 16.6085 19.8946 16.5096 19.9935C16.4107 20.0924 16.2766 20.1479 16.1367 20.1479Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.69922 7.4917H10.8633C11.0031 7.4917 11.1373 7.54726 11.2362 7.64615C11.3351 7.74505 11.3906 7.87918 11.3906 8.01904V10.6558H7.17188V8.01904C7.17188 7.87918 7.22743 7.74505 7.32633 7.64615C7.42523 7.54726 7.55936 7.4917 7.69922 7.4917Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.918 5.38232H15.082C15.2219 5.38232 15.356 5.43788 15.4549 5.53678C15.5538 5.63568 15.6094 5.76981 15.6094 5.90967V10.6558H11.3906V5.90967C11.3906 5.76981 11.4462 5.63568 11.5451 5.53678C11.644 5.43788 11.7781 5.38232 11.918 5.38232V5.38232Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1367 6.43701H19.3008C19.4406 6.43701 19.5748 6.49257 19.6737 6.59147C19.7726 6.69036 19.8281 6.8245 19.8281 6.96436V10.6558H15.6094V6.96436C15.6094 6.8245 15.6649 6.69036 15.7638 6.59147C15.8627 6.49257 15.9969 6.43701 16.1367 6.43701Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5183_28560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.875,
    height: 16.875,
    fill: "white",
    transform: "translate(5.0625 5.38232)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.639f611ed93de96580bb58d426a65eed.svg";
export { ForwardRef as ReactComponent };